import { useEffect } from "react";
import { useParams, Navigate, useLocation } from "react-router-dom";

// Map old Squarespace /happenings/f/<slug> URLs to current routes.
// Slugs are matched case-insensitively against the decoded URL pathname.
const HAPPENINGS_MAP: Record<string, string> = {
  "an-affordable-fun-memorable-spring-break-getaway": "/blog/spring-break-sons-river-ranch",
  "exclusive-new-braunfels-vacation-destinations-and-beyond": "/blog/family-things-to-do-new-braunfels",
  "plan-a-romantic-getaway-near-san-antonio-in-a-creekside-cabin": "/blog/romantic-getaways-near-san-antonio",
  "son's-island-getaways-guide-|-a-look-at-our-texas-resorts": "/",
  "sons-island-getaways-guide-a-look-at-our-texas-resorts": "/",
  "top-7-best-places-to-stay-in-seguin-texas": "/things-to-do-seguin",
  "vacation-rental-cabins-near-new-braunfels": "/blog/cabana-rentals-near-san-antonio",
};

export const HappeningsRedirect = () => {
  const { slug } = useParams<{ slug: string }>();
  const key = (slug ?? "").toLowerCase();
  const target = HAPPENINGS_MAP[key] ?? "/blog";
  useEffect(() => {
    // Best-effort signal to crawlers that this is a permanent move.
    document.title = "Redirecting…";
  }, []);
  return <Navigate to={target} replace />;
};

export const HappeningsCatchAll = () => <Navigate to="/blog" replace />;

export const SimpleRedirect = ({ to }: { to: string }) => {
  const location = useLocation();
  useEffect(() => {
    document.title = "Redirecting…";
  }, [location.pathname]);
  return <Navigate to={to} replace />;
};